'use strict';
const getAdminUrls = require('./getUrls');
const getMainUrls = require('getUrls');

module.exports = {
  'organisations': getAdminUrls.getOrganisationUrl(),
  'books-subscription': getAdminUrls.getAdminBooksSubscriptionUrl(),
  'inspection-coach': getAdminUrls.getAdminInspectionCoachUrl(),
  'questionnaires': getAdminUrls.getAdminQuestionnairesUrl(),
  'frameworks': getAdminUrls.getAdminFrameworksUrl(),
  'observation-notes': getAdminUrls.getAdminObservationNotesUrl(),
  'observation-objectives': getAdminUrls.getAdminObservationObjectivesUrl(),
  'report-templates': getAdminUrls.getAdminReportTemplates(),
  'assessment': getAdminUrls.getAdminAssessment(),
  'parent-share': getAdminUrls.getAdminParentShare(),
  '2bap-settings': getAdminUrls.getAdmin2bapSettings(),
  'sector-areas': getAdminUrls.getAdminSectorAreasUrl(),
  'activity-log': getAdminUrls.getActivityLogUrl(),
  'configure-plans': getAdminUrls.getConfigurePlans(),
  'my-profile': getAdminUrls.getMyProfileUrl(),
  'logout': getMainUrls.getLogoutUrl(),
};
